import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/site";
import { Handshake, History, ShieldCheck } from "lucide-react";

const pillars = [
  {
    icon: History,
    title: "A Texas family business",
    text: "Family owned since 1991 — serving Texas communities from three showrooms, with the same faces and the same standards.",
  },
  {
    icon: Handshake,
    title: "Real jewelry expertise",
    text: "Repairs, custom design, diamond setting and watch servicing done by our own team — your pieces never leave trusted hands.",
  },
  {
    icon: ShieldCheck,
    title: "Inspected with care",
    text: "Showroom and pre-owned pieces are checked by our team — watches authenticated, gold assayed, diamonds reviewed — before they're offered to you.",
  },
];

export const Heritage = () => {
  return (
    <section id="promise" data-testid="promise-section" className="py-24 lg:py-32 bg-white border-y border-[#E8DCC4]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Our Promise</Eyebrow>
            <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-neutral-900" data-testid="promise-heading">
              Trusted by the community <span className="text-[#C9A227]">since 1991</span>
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-neutral-600 max-w-xl">
              Whether you're choosing a watch you'll wear for decades, restoring a family piece,
              or designing something custom — you deserve straight answers and real craftsmanship.
              That's how a family business earns its name, and keeps it.
            </p>
          </Reveal>

          <div className="mt-12 space-y-8">
            {pillars.map(({ icon: Icon, title, text }, i) => (
              <Reveal key={title} delay={0.1 * (i + 1)}>
                <div className="flex items-start gap-5" data-testid={`promise-pillar-${i}`}>
                  <Icon size={24} strokeWidth={1} className="text-[#C9A227] mt-1 shrink-0" />
                  <div>
                    <h3 className="text-lg font-semibold text-neutral-800">{title}</h3>
                    <p className="text-sm md:text-base text-neutral-600 mt-1 leading-relaxed max-w-md">{text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-6 items-center">
            <div className="overflow-hidden rounded-sm">
              <img
                src={IMAGES.precision}
                alt="Watchmaker servicing a fine watch movement"
                data-testid="promise-image-precision"
                className="w-full h-[320px] lg:h-[400px] object-cover hover:scale-105 transition-transform duration-700 ease-out"
              />
            </div>
            <div className="overflow-hidden rounded-sm">
              <img
                src={IMAGES.craft}
                alt="Jeweler setting a diamond ring at the workbench"
                data-testid="promise-image-diamond"
                className="w-full h-[320px] lg:h-[400px] object-cover hover:scale-105 transition-transform duration-700 ease-out"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
